import React from "react";
import { Dialog, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./TeaLoadingModal.css";

const TeaLoadingModal = ({
  open,
  onClose,
  message = "We're working on your post — till then, have a cup of tea.",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "18px",
          textAlign: "center",
          position: "relative",
          boxShadow: "0px 12px 32px rgba(0, 0, 0, 0.12)",
          overflow: "visible",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.35)",
          backdropFilter: "blur(3px)",
        },
      }}
    >
      {/* Close button X */}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 14,
          right: 14,
          color: "#000000",
          backgroundColor: "transparent",
          "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
        }}
      >
        <CloseIcon sx={{ fontSize: 22 }} />
      </IconButton>

      {/* Coffee/Tea Cup Animated Illustration */}
      <Box sx={{ display: "flex", justifyContent: "center", mb: 3, mt: 1 }}>
        <svg
          width="130"
          height="120"
          viewBox="0 0 130 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="tea-cup-svg"
        >
          {/* Steam paths */}
          <path
            className="tea-steam steam-1"
            d="M50 40 C46 34 54 30 50 24 C46 18 54 14 50 8"
            stroke="#CBE4EB"
            strokeWidth="3.5"
            strokeLinecap="round"
          />
          <path
            className="tea-steam steam-2"
            d="M65 36 C61 30 69 26 65 20 C61 14 69 10 65 4"
            stroke="#DFEFF3"
            strokeWidth="3.5"
            strokeLinecap="round"
          />
          <path
            className="tea-steam steam-3"
            d="M80 42 C76 36 84 32 80 26 C76 20 84 16 80 10"
            stroke="#CBE4EB"
            strokeWidth="3.5"
            strokeLinecap="round"
          />

          {/* Saucer Outer */}
          <ellipse cx="65" cy="96" rx="44" ry="11" fill="#EBF2F5" />
          {/* Saucer Inner Ring */}
          <ellipse cx="65" cy="96" rx="38" ry="8" fill="#8ACAD6" />
          <ellipse cx="65" cy="96" rx="32" ry="6" fill="#DDF0F4" />

          {/* Cup Outer Body */}
          <path
            d="M36 50 C36 50 38 88 65 88 C92 88 94 50 94 50 Z"
            fill="#EFF7F9"
            stroke="#8ACAD6"
            strokeWidth="4"
          />

          {/* Cup Handle */}
          <path
            d="M92 56 C106 56 110 74 92 80"
            fill="none"
            stroke="#8ACAD6"
            strokeWidth="4.5"
            strokeLinecap="round"
          />

          {/* Cup Rim Top */}
          <ellipse cx="65" cy="50" rx="29" ry="7" fill="#EFF7F9" stroke="#8ACAD6" strokeWidth="3" />

          {/* Coffee / Tea Liquid */}
          <ellipse cx="65" cy="50" rx="25" ry="5.2" fill="#6E472E" />

          {/* Swirls on Coffee Surface */}
          <ellipse cx="63" cy="50" rx="16" ry="3.2" fill="#996A4A" />
          <ellipse cx="61" cy="50" rx="8" ry="1.6" fill="#BC9174" />
        </svg>
      </Box>

      {/* Message Text */}
      <Typography
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontSize: "17px",
          fontWeight: 500,
          color: "#3B3B3B",
          lineHeight: 1.5,
          px: 1,
          whiteSpace: "pre-line",
        }}
      >
        {message}
      </Typography>
    </Dialog>
  );
};

export default TeaLoadingModal;
